import { ORDERS_LIST_PATH } from '@/constants/ordersList';

/**
 * Собирает адрес запроса заказов. Уходят только строки и числа; пустые
 * значения (`undefined`, `''`) не отправляются вовсе: `client_name=` ломает
 * выдачу.
 *
 * @param filters - параметры запроса
 * @param path - путь ручки от корня API; по умолчанию — список заказов v2
 * @returns абсолютный адрес с query-строкой
 */
export const createOrdersUrl = <T extends object>(
  filters: T,
  path: string = ORDERS_LIST_PATH
): string => {
  const params = new URLSearchParams();

  Object.entries(filters).forEach(([key, value]: [string, unknown]) => {
    if (
      typeof value === 'number' ||
      (typeof value === 'string' && value !== '')
    ) {
      params.set(key, String(value));
    }
  });

  return `${import.meta.env.VITE_API_URL}${path}?${params.toString()}`;
};
